import { render, staticRenderFns } from "./ConfirmOverlay.vue?vue&type=template&id=37c6b432&scoped=true&"
import script from "./ConfirmOverlay.vue?vue&type=script&lang=js&"
export * from "./ConfirmOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOverlay.vue?vue&type=style&index=0&id=37c6b432&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6b432",
  null
  
)

export default component.exports